<template>
  <textarea
      class="elastic__textarea"
      v-model="currentValue"
      @input="resize"
      @focus="resize"
      ref="textarea"
  ></textarea>
</template>

<script>
export default {
    name: 'ElasticTextarea',
    data() {
        return {
            currentValue: '',
            initialized: false,
        };
    },
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        stripTags: {
            type: Boolean,
            default: true,
        },
        rows: {
            type: Number,
            default: 2,
        },
    },
    watch: {
        currentValue() {
            this.resize();
            this.emitValue();
        },
        value(val) {
            // eslint-disable-next-line no-nested-ternary
            this.currentValue = (val ? (this.stripTags ? val.replace(/(<([^>]+)>)/ig, '') : val) : '');
        },
    },
    methods: {
        resize() {
            const { textarea } = this.$refs;
            textarea.style.height = 'auto';
            const minHeight = (this.rows * 20) + 16;
            textarea.style.height = Math.max(minHeight, textarea.scrollHeight + textarea.offsetHeight - textarea.clientHeight) + 'px';
        },
        // eslint-disable-next-line func-names
        emitValue() {
            if (this.initialized) {
                this.$emit('input', this.currentValue);
            }
        },
    },
    mounted() {
        // eslint-disable-next-line no-nested-ternary
        this.currentValue = (this.value ? (this.stripTags ? this.value.replace(/(<([^>]+)>)/ig, '') : this.value) : '');
        this.$nextTick(() => {
            this.resize();
            this.initialized = true;
        });
    },
};
</script>

<style scoped>
.elastic__textarea {
    resize: none;
    box-sizing: border-box;
    overflow: hidden;
    min-height: 60px;
}
</style>
